module.exports = __webpack_public_path__ + "static/bg (7)-e852e0c697954a90e2e836c9d266b3de.jpg";